import { render, staticRenderFns } from "./GroupGrid.vue?vue&type=template&id=63a8fe56&scoped=true"
import script from "./GroupGrid.vue?vue&type=script&lang=js"
export * from "./GroupGrid.vue?vue&type=script&lang=js"
import style0 from "./GroupGrid.vue?vue&type=style&index=0&id=63a8fe56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8fe56",
  null
  
)

export default component.exports